import { SISR_TOKEN } from "../../utils/access/constants";
import { login } from "../../utils/user/api";
import { nameRoutes } from "../../router/nameRoutes";
import { makeToast, TOAST_RESULT } from "../../Toast";

import LABEL from "../../utils/label";
import { URL_APPLICATIVO, NOME_FILE_MANUALE_USO } from "../../utils/commons";

export const loginMixin = {
  data: () => ({
    LABEL,
    URL_APPLICATIVO,
    NOME_FILE_MANUALE_USO,
    loader: {
      login: false,
    },
    utente: {
      braccialetto: "",
      password: "",
    },
    errors: {
      braccialetto: false,
      password: false,
      loginError: false,
    },
  }),
  methods: {
    access: async function () {
      let stopLogin = false;
      Object.keys(this.errors).map((error) => {
        this.validate(error);
        if (this.errors[error]) stopLogin = true;
      });
      if (stopLogin) {
        this.removeError();
        return;
      }

      this.loader.login = true;
      const { data, result, code } = await login({
        braccialetto: this.utente.braccialetto,
        password: this.utente.password,
      });

      this.errors.loginError = result === "KO";
      if (result === "OK") {
        localStorage.setItem(SISR_TOKEN, data);
        this.$router.push({ name: nameRoutes.BENVENUTO });
      } else makeToast(TOAST_RESULT.KO, LABEL.TOAST[code]);
      this.loader.login = false;
    },
    validate: function (campo) {
      switch (campo) {
        case "braccialetto":
          //CONTROLLO CHE IL BRACCIALETTO SIA VALIDO CON UNA REGEX
          this.errors.braccialetto = this.utente.braccialetto === "";
          break;
        case "password":
          //CONTROLLO CHE LA PASSWORD SIA VALIDA CON UNA REGEX
          this.errors.password = this.utente.password === "";
          break;
      }
    },
    removeError: function () {
      setTimeout(() => {
        this.errors = { braccialetto: false, password: false };
      }, 800);
    },
    updateAccessError: function () {
      this.errors.loginError = !this.errors.loginError;
    },
  },
};
